import React, { useState } from 'react';
import { PasscodeGate } from './components/PasscodeGate';
import { ProductionVisionStudio } from './components/ProductionVisionStudio';

const AUTH_STORAGE_KEY = 'fridge_vision_auth_session';

export const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(AUTH_STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });

  const handleAuthenticated = () => {
    setIsAuthenticated(true);
    try {
      sessionStorage.setItem(AUTH_STORAGE_KEY, 'true');
    } catch (e) {
      console.warn('Session storage write error', e);
    }
  };

  const handleLock = () => {
    setIsAuthenticated(false);
    try {
      sessionStorage.removeItem(AUTH_STORAGE_KEY);
    } catch (e) {
      console.warn('Session storage remove error', e);
    }
  };

  if (!isAuthenticated) {
    return (
      <PasscodeGate
        onAuthenticated={handleAuthenticated}
        savedPasscode="refrigerator"
      />
    );
  }

  return <ProductionVisionStudio onLock={handleLock} />;
};
